import type React from 'react';
import { lazy, Suspense } from 'react';
import useModal from 'hooks/useModal';
import CustomLoader from 'components/molecules/CustomLoader.component';
const UnifiedBankingSignupFlow = lazy(
  // Lazy loading breaks runtime cycle - ESLint can't detect dynamic imports
  // eslint-disable-next-line import/no-cycle
  () => import('./components/./UnifiedBankingSignupFlow'),
);

export type UseWalletOnboardingModalAPI = {
  open: (initialScreenIndex?: number) => void;
  close: () => void;
};

type UseWalletOnboardingModalReturn = [
  React.ReactNode,
  UseWalletOnboardingModalAPI,
];

const useWalletOnboardingModal = (): UseWalletOnboardingModalReturn => {
  const [modalContent, modalApi] = useModal({
    width: '2xl',
    name: 'wallet-onboarding-modal',
    color: 'bank',
    className: '!max-w-[40rem] useWalletOnboardingModal',
  });

  const api: UseWalletOnboardingModalAPI = {
    open: (initialScreenIndex?: number) => {
      modalApi.open(() => (
        <Suspense fallback={<CustomLoader />}>
          <UnifiedBankingSignupFlow
            initialScreenIndex={initialScreenIndex}
            onComplete={modalApi.close}
          />
        </Suspense>
      ));
    },
    close: modalApi.close,
  };

  return [modalContent, api];
};

export default useWalletOnboardingModal;
